import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Group as AriaGroup, GroupProps } from "react-aria-components";

import { useInputStyles } from "../../styles";

export function _Group(props: GroupProps) {
  const style = useInputStyles();
  const className = css(style, styles.group);

  return <AriaGroup {...mergeProps(props, { className })} />;
}

const styles = {
  group: css({
    height: "var(--space-10)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px var(--space-3)",
  }),
};
